<template>
  <div class="transfer-contacts">
    <div class="transfer-content">
      <div class="description">
        Bu işlem, seçilen kanaldaki tüm kullanıcıları başka bir kanala taşıyacaktır.
      </div>
      
      <div class="channel-selection">
        <label>Hedef Kanal</label>
        <ChannelPicker
          v-model="selectedChannelId"
          :filter-deleted="true"
          :allowed-types="filterTypes"
          placeholder="Kanal seçin"
        />
      </div>
      
      <div class="buttons-wrapper">
        <SupsisButton @click="$emit('cancel')" secondary>
          İptal
        </SupsisButton>
        <SupsisButton @click="startTransfer" primary :disabled="!selectedChannelId">
          Transfer Et
        </SupsisButton>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import ChannelPicker from "../../../components/pickers/ChannelPicker.vue";
import SupsisButton from "../Settings/components/SupsisButton.vue";

export default Vue.extend({
  name: "TransferContacts",
  components: {
    ChannelPicker,
    SupsisButton
  },
  props: {
    channelId: {
      type: String,
      required: true
    },
    filterTypes: {
      type: Array,
      default: () => ["whatsapp-qr", "whatsapp-v2", "whatsapp-unipile", "whatsapp-v1", "whatsapp-business-api"]
    }
  },
  data() {
    return {
      selectedChannelId: ""
    };
  },
  computed: {
    ...mapState({
      siteId: state => state.site.site._id,
      channels: state => state.channel.channels
    }),
    ...mapGetters({
      getChannel: "channel/getChannel"
    }),
    activeChannels() {
      return this.channels.filter(ch => 
        this.filterTypes.includes(ch.type) && 
        !ch.isDeleted && 
        ch._id !== this.channelId
      );
    }
  },
  methods: {
    startTransfer() {
      if (!this.selectedChannelId) {
        this.$message.error("Lütfen bir hedef kanal seçin");
        return;
      }
      
      this.$emit("transfer", this.selectedChannelId);
    }
  },
  watch: {
    selectedChannelId(newVal) {
      this.$emit("update:targetChannelId", newVal);
    }
  }
});
</script>

<style lang="scss" scoped>
.transfer-contacts {
  padding: 20px;
  
  .transfer-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    
    .description {
      font-size: 14px;
      margin-bottom: 10px;
    }
    
    .channel-selection {
      display: flex;
      flex-direction: column;
      gap: 8px;
      
      label {
        font-weight: 600;
      }
    }
    
    .buttons-wrapper {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      margin-top: 10px;
    }
  }
}
</style> 